import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { lightTheme } from "../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from '@material-ui/core/Tooltip';
import SwipeableDrawerSection from "./SwipeDrawer";
import LogoutIcon from '../../src/assets/icons/logout-white.svg';

export default function AppHeader(props) {
    const anchor = "left";
    //console.log("props", props);
    //console.log("props1", props1);
    //let defaultUrl = window.location.href;

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <div
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
        </div>
    );

    //const logout = () => {
    //    props.logoutClick();         
    //}

    const handleLogout = () => {
        localStorage.clear();

        window.location.reload();
    }

    return (
        <ThemeProvider theme = { lightTheme }>
            <AppBar position="fixed" className="no-print">
                <Toolbar className={"header-light-bg"}>
                    <React.Fragment key={anchor}>
                        <SwipeableDrawerSection
                            //loginDetails={props.loginDetails}
                            className="height-inherit bg-dark-blue"
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            onOpen={toggleDrawer(anchor, true)}
                            roleId={props.role}
                            phyInvroleId={props.pyinvrole}
                        >
                            {list(anchor)}
                        </SwipeableDrawerSection>
                    </React.Fragment>
                    <div className={"d-flex flex-wrap pt-8 jc-space-bt align-item-center width-100"}>
                        <a href="/" rel="">
                            <img src={"../assets/images/siemens-logo-white.svg"} alt="Siemens Company Logo" width="125" height="20" className="siemens-logo" />
                        </a>
                    </div>
                    <React.Fragment>
                        <a href="../Login/Logout" onClick={handleLogout}>
                           
                            <Tooltip title="Logout">
                                <img src={LogoutIcon} alt="logout" />
                            </Tooltip>
                        </a>
                    </React.Fragment>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    );
}
